import React, { PureComponent } from 'react'
// import { Col } from 'react-bootstrap'
import { Field } from 'redux-form'
import InputCheckBox from '../../../../components/commons/form/InputCheckBox'
import InputSelect from '../../../../components/commons/form/InputSelect'
import InputText from '../../../../components/commons/form/InputText'
import { entityTypesId, permissions } from '../../../../constants/backendIds'
import { dossierTypes as dossierTypesConstant } from '../../../../constants/dossier/common/dossierTypes'
import { dossierSubTypeId as dossierSubTypeConstant } from '../../../../constants/dossier/common/dossierSubType'
import { comboType, numberCombo } from '../../../../constants/dossier/common/client'

class FinalClient extends PureComponent {
  constructor (props) {
    super()
    this.state = {
      combo: 0,
      alert: true,
      freeLance: false
    }
  }

  componentDidUpdate () {
    if (this.state.alert && this.props.combos[`entity${comboType[this.state.combo]}`]?.length === 0 && this.props.combos[`entity${comboType[this.state.combo - 1]}`]?.length > 0) {
      const alert = 'notData'
      this.props.actions.openCommonModal(alert)
      this.setState({
        combo: this.state.combo - 1,
        alert: false
      })
      if (this.state.combo !== numberCombo.postalCodeCode) {
        this.props.actions[`fetchEntity${comboType[this.state.combo]}`]()
      }
    }
  }

  handleEntityTypesChange (code, disable) {
    if (code) {
      if (disable !== 5) {
        this.props.actions[`fetchEntity${comboType[disable + 1]}`](this.props.combos[`entity${comboType[disable]}`].find(x => x.code === code)?.id)
        this.setState({
          notData: false
        })
        this.AddCombo()
      }
    } else {
      this.setState({ combo: (disable !== 0) ? disable - 1 : disable, alert: true })
    }
  }

  AddCombo () {
    this.setState({
      combo: this.state.combo + 1
    })
  }

  setValidationDisable (disableDniCifValidation, disableRepDniCifValidation, disableChildDniCifValidation, disableChildRepDniCifValidation) {
    if (disableChildDniCifValidation) {
      var okAction = () => {
        this.props.actions.setEntityValidationDisable(this.props.dossierType, disableDniCifValidation, disableRepDniCifValidation, disableChildDniCifValidation, disableChildRepDniCifValidation)
        this.props.actions.asyncValidate({ entityChildComponent: { ...this.props.formValues.entityChildComponent, disableChildDniCifValidation: disableChildDniCifValidation, freeLance: this.state.freeLance } }, this.props.actions.dispatch, this.props, 'dniCif', true)
          .then((result) => {
            this.props.actions.stopAsyncValidation({ ...result })
          })
      }

      var cancelAction = () => { this.props.actions.change('entityChildComponent.dniCifValidationDisable', false) }

      this.props.actions.openCommonModal('setValidationDisableModal', okAction, cancelAction, null, null, null, null)
    } else {
      this.props.actions.setEntityValidationDisable(this.props.dossierType, disableDniCifValidation, disableRepDniCifValidation, disableChildDniCifValidation, disableChildRepDniCifValidation)
      if (disableChildDniCifValidation !== null && disableChildDniCifValidation !== undefined) {
        this.props.actions.asyncValidate({ entityChildComponent: { ...this.props.formValues.entityChildComponent, dniCifValidationDisable: disableChildDniCifValidation, freeLance: this.state.freeLance } }, this.props.actions.dispatch, this.props, 'dniCif', true)
          .then((result) => {
            this.props.actions.stopAsyncValidation({ ...result })
          })
      }
      if (disableChildRepDniCifValidation !== null && disableChildRepDniCifValidation !== undefined) {
        this.props.actions.asyncValidate({ entityChildComponent: { ...this.props.formValues.entityChildComponent, representativeDniCifValidationDisable: disableChildRepDniCifValidation, freeLance: this.state.freeLance } }, this.props.actions.dispatch, this.props, 'representativeDni', true).then((result) => {
          this.props.actions.stopAsyncValidation({ ...result })
        })
      }
    }
  }

  getEntityChild (value) {
    const dniCif = value
    if (value) {
      new Promise((resolve) => {
        this.props.actions.fetchClientByDniEntityChild(dniCif, this.props.dossier.organizedUnitId, this.props.dossierType, resolve)
      }).then(() => {
      })
    }
  }

  getEntityRfc (value) {
    const rfc = value
    if (value) {
      new Promise((resolve) => {
        return this.props.actions.checkPrivateRfcFormat(value, resolve)
      }).then((confirm) => {
        if (confirm) {
          new Promise((resolve) => {
            this.props.actions.fetchClientByRfc(rfc, this.props.dossier.organizedUnitId, this.props.dossierType, resolve)
          }).then(() => {
          })
        } else {
          this.props.change('entityComponent.rfc', null)
        }
      })
    }
  }

  getEntityTypeLabel () {
    const tKey = 'DOSSIER_COMPONENTS.ENTITY.'
    switch (this.props.dossierType) {
      case dossierTypesConstant.sales:
      case dossierTypesConstant.addNewFleetModal:
      case dossierTypesConstant.createNewFleetModal:
      case dossierTypesConstant.dataContactFleetModal:
        return this.props.t(`${tKey}CLIENT_TYPE`)
      case dossierTypesConstant.purchase:
        return this.props.t(`${tKey}VENDOR_TYPE`)
      default:
        switch (this.getSubTypePapeworkRelatedDossier()) {
          case dossierSubTypeConstant.compra_vo:
            return this.props.t(`${tKey}ENTITY_VENDOR`)
          case dossierSubTypeConstant.venta_vo:
            return this.props.t(`${tKey}ENTITY_BUYER`)
          default:
            return this.props.t(`${tKey}ENTITY_TYPE`)
        }
    }
  }

  getSubTypePapeworkRelatedDossier () {
    if (this.props.dossier.dossierRelatedDossiers && this.props.dossier.dossierRelatedDossiers.length) {
      const paperworkRelatedDossier = this.props.dossier.dossierRelatedDossiers[0]
      return paperworkRelatedDossier.dossierSubType
    }
  }

  removeRecurrentEntityTypeFromCombo (entityTypeCombo) {
    var entityTypeComboNoRecurrent = []
    for (const entity of entityTypeCombo) {
      if (entity.id !== entityTypesId.recurrentEntity) {
        entityTypeComboNoRecurrent.push(entity)
      }
    }
    return entityTypeComboNoRecurrent
  }

  onEntityChildTypeIdChanges (entityTypeId) {
    new Promise((resolve, reject) => {
      return this.props.actions.setEntityChildTypeId(entityTypeId, this.props.dossier.entityChildComponent.entityTypeId, this.props.dossierType, resolve, reject)
    }).then(() => {
      if (entityTypeId === entityTypesId.recurrentEntity) this.props.actions.fetchEntitySubTypeCombo(entityTypeId)
    })
  }

  getNumberLabel () {
    const tKey = 'DOSSIER_COMPONENTS.ENTITY.'
    switch (this.props.dossierType) {
      case dossierTypesConstant.sales:
      case dossierTypesConstant.addNewFleetModal:
      case dossierTypesConstant.createNewFleetModal:
      case dossierTypesConstant.dataContactFleetModal:
        return this.props.t(`${tKey}MAIN_CLIENT_NUMBER`)
      case dossierTypesConstant.purchase:
        return this.props.t(`${tKey}MAIN_VENDOR_NUMBER`)
      default:
        switch (this.getSubTypePapeworkRelatedDossier()) {
          case dossierSubTypeConstant.compra_vo:
            return this.props.t(`${tKey}MAIN_ENTITY_VENDOR_NUMBER`)
          case dossierSubTypeConstant.venta_vo:
            return this.props.t(`${tKey}MAIN_ENTITY_BUYER_NUMBER`)
          default:
            return this.props.t(`${tKey}MAIN_ENTITY_NUMBER`)
        }
    }
  }

  setFreelance (value) {
    this.setState({ freeLance: value })

    this.props.actions.asyncValidate({ entityChildComponent: { ...this.props.formValues.entityChildComponent, disableChildDniCifValidation: this.props.dossier?.entityChildComponent?.disableChildDniCifValidation, freeLance: value } }, this.props.actions.dispatch, this.props, 'dniCif', true)
      .then((result) => {
        this.props.actions.stopAsyncValidation({ ...result })
      })
  }

  shortSchema () {
    const {
      t,
      fieldsConfiguration,
      readOnlyFields,
      isRecurrentEntityType,
      disabledByNotSelectedEntityChildTypeId,
      dossier: {
        entityChildComponent,
        salesComponent
      },
      combos: {
        entityTypeCombo,
        iaeTypeCombo
      }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.ENTITY.'
    return (
      <>
        {fieldsConfiguration.entityTypeIdChild &&
        fieldsConfiguration.entityTypeIdChild.permission !==
          permissions.hidden && (
          <Field
            component={InputSelect}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            id='entityTypeIdChild'
            name='entityChildComponent.entityTypeId'
            controlLabel={this.getEntityTypeLabel()}
            placeholder={this.getEntityTypeLabel()}
            options={this.removeRecurrentEntityTypeFromCombo(
              entityTypeCombo
            )}
            onInputChange={this.onEntityChildTypeIdChanges.bind(this)}
            valueKey='id'
            labelKey='value'
            disabled={
              readOnlyFields ||
              entityChildComponent.entityId ||
              fieldsConfiguration.entityTypeIdChild
                .permission !== permissions.editable
            }
          />
        )}
        {fieldsConfiguration.dniCifChild &&
        fieldsConfiguration.dniCifChild.permission !==
          permissions.hidden && (
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            id='dniCifChild'
            name='entityChildComponent.dniCif'
            disabled={
              (isRecurrentEntityType ||
              salesComponent?.clientNotEmployeeCheck
                ? readOnlyFields ||
                  fieldsConfiguration.dniCifChild.permission !==
                    permissions.editable
                : true) ||
              entityChildComponent.entityId ||
              disabledByNotSelectedEntityChildTypeId
            }
            controlLabel={t(`${tKey}DNI`)}
            placeholder={t(`${tKey}DNI`)}
            onInputBlur={(event) => this.getEntityChild(event)}
            maxLength={20}
          />
        )}
        {entityChildComponent.entityTypeId !==
        entityTypesId.recurrentEntity && [
          fieldsConfiguration.clientNumberChild &&
          fieldsConfiguration.clientNumberChild.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='clientNumberChild'
              name='entityChildComponent.clientNumber'
              key='entityChildComponent.clientNumber'
              controlLabel={this.getNumberLabel()}
              placeholder={this.getNumberLabel()}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.clientNumberChild
                  .permission !== permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
              forceControlLabelInOneLine={true}
            />
          )
        ]}
        {(entityChildComponent.entityTypeId === entityTypesId.privateEntity ||
        entityChildComponent.entityTypeId ===
          entityTypesId.businessEntity) &&
        fieldsConfiguration.nameChild &&
        fieldsConfiguration.nameChild.permission !==
          permissions.hidden && (
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            id='nameChild'
            name='entityChildComponent.name'
            key='entityChildComponent.name'
            controlLabel={t(`${tKey}NAME`)}
            placeholder={t(`${tKey}NAME`)}
            disabled={
              readOnlyFields ||
              fieldsConfiguration.nameChild.permission !==
                permissions.editable ||
              disabledByNotSelectedEntityChildTypeId
            }
          />
        )}
        {entityChildComponent.entityTypeId ===
        entityTypesId.privateEntity && [
          fieldsConfiguration.surname1Child &&
          fieldsConfiguration.surname1Child.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='surname1Child'
              name='entityChildComponent.surname1'
              key='entityChildComponent.surname1'
              controlLabel={t(`${tKey}SURNAME1`)}
              placeholder={t(`${tKey}SURNAME1`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.surname1Child.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.surname2Child &&
          fieldsConfiguration.surname2Child.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='surname2Child'
              name='entityChildComponent.surname2'
              key='entityChildComponent.surname2'
              controlLabel={t(`${tKey}SURNAME2`)}
              placeholder={t(`${tKey}SURNAME2`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.surname2Child.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          )
        ]}
        {entityChildComponent.entityTypeId ===
        entityTypesId.businessEntity && [
          fieldsConfiguration.representativeDniChild &&
          fieldsConfiguration.representativeDniChild
            .permission !== permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='representativeDniChild'
              name='entityChildComponent.representativeDni'
              key='entityChildComponent.representativeDni'
              controlLabel={t(`${tKey}REPRESENTATIVE_DNI`)}
              placeholder={t(`${tKey}REPRESENTATIVE_DNI`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.representativeDniChild
                  .permission !== permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.representativeNameChild &&
          fieldsConfiguration.representativeNameChild
            .permission !== permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='representativeNameChild'
              name='entityChildComponent.representativeName'
              key='entityChildComponent.representativeName'
              controlLabel={t(`${tKey}REPRESENTATIVE_NAME`)}
              placeholder={t(`${tKey}REPRESENTATIVE_NAME`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.representativeNameChild
                  .permission !== permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.representativeSurname1Child &&
          fieldsConfiguration.representativeSurname1Child
            .permission !== permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='representativeSurname1Child'
              name='entityChildComponent.representativeSurname1'
              key='entityChildComponent.representativeSurname1'
              controlLabel={t(`${tKey}REPRESENTATIVE_SURNAME1`)}
              placeholder={t(`${tKey}REPRESENTATIVE_SURNAME1`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.representativeSurname1Child
                  .permission !== permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
              forceControlLabelInOneLine={true}
            />
          ),
          fieldsConfiguration.representativeSurname2Child &&
          fieldsConfiguration.representativeSurname2Child
            .permission !== permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='representativeSurname2Child'
              name='entityChildComponent.representativeSurname2'
              key='entityChildComponent.representativeSurname2'
              controlLabel={t(`${tKey}REPRESENTATIVE_SURNAME2`)}
              placeholder={t(`${tKey}REPRESENTATIVE_SURNAME2`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.representativeSurname2Child
                  .permission !== permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
              forceControlLabelInOneLine={true}
            />
          )
        ]}
        {entityChildComponent.entityTypeId !==
        entityTypesId.recurrentEntity && [
          fieldsConfiguration.addressChild &&
          fieldsConfiguration.addressChild.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='addressChild'
              name='entityChildComponent.address'
              key='entityChildComponent.address'
              controlLabel={t(`${tKey}ADDRESS`)}
              placeholder={t(`${tKey}ADDRESS`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.addressChild.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.cityChild &&
          fieldsConfiguration.cityChild.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='cityChild'
              name='entityChildComponent.city'
              key='entityChildComponent.city'
              controlLabel={t(`${tKey}CITY`)}
              placeholder={t(`${tKey}CITY`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.cityChild.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.stateChild &&
          fieldsConfiguration.stateChild.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='stateChild'
              name='entityChildComponent.state'
              key='entityChildComponent.state'
              controlLabel={t(`${tKey}STATE`)}
              placeholder={t(`${tKey}STATE`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.stateChild.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.cpChild &&
          fieldsConfiguration.cpChild.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='cpChild'
              name='entityChildComponent.cp'
              key='entityChildComponent.cp'
              controlLabel={t(`${tKey}CP`)}
              placeholder={t(`${tKey}CP`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.cpChild.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.countryChild &&
          fieldsConfiguration.countryChild.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='countryChild'
              name='entityChildComponent.country'
              key='entityChildComponent.country'
              controlLabel={t(`${tKey}COUNTRY`)}
              placeholder={t(`${tKey}COUNTRY`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.countryChild.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.phoneChild &&
          fieldsConfiguration.phoneChild.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='phoneChild'
              name='entityChildComponent.phone'
              key='entityChildComponent.phone'
              controlLabel={t(`${tKey}PHONE`)}
              placeholder={t(`${tKey}PHONE`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.phoneChild.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.mobilePhoneChild &&
          fieldsConfiguration.mobilePhoneChild.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='mobilePhoneChild'
              name='entityChildComponent.mobilePhone'
              key='entityChildComponent.mobilePhone'
              controlLabel={t(`${tKey}MOBILE`)}
              placeholder={t(`${tKey}MOBILE`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.mobilePhoneChild
                  .permission !== permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.emailChild &&
          fieldsConfiguration.emailChild.permission !==
            permissions.hidden && (
            <Field
              component={InputText}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='emailChild'
              name='entityChildComponent.email'
              key='entityChildComponent.email'
              controlLabel={t(`${tKey}EMAIL`)}
              placeholder={t(`${tKey}EMAIL`)}
              disabled={
                readOnlyFields ||
                fieldsConfiguration.emailChild.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          ),
          fieldsConfiguration.iaeTypeIdChild &&
          fieldsConfiguration.iaeTypeIdChild.permission !==
            permissions.hidden &&
          entityChildComponent.entityTypeId ===
            entityTypesId.businessEntity && (
            <Field
              component={InputSelect}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='iaeTypeIdChild'
              name='entityChildComponent.iaeTypeId'
              key='entityChildComponent.iaeTypeId'
              controlLabel={t(`${tKey}IAE_TYPE`)}
              placeholder={t(`${tKey}IAE_TYPE`)}
              options={iaeTypeCombo}
              valueKey='id'
              labelKey='value'
              disabled={
                readOnlyFields ||
                fieldsConfiguration.iaeTypeIdChild.permission !==
                  permissions.editable ||
                disabledByNotSelectedEntityChildTypeId
              }
            />
          )
        ]}
        {fieldsConfiguration.rfcChild &&
        fieldsConfiguration.rfcChild.permission !==
          permissions.hidden && (
          <Field
            component={InputText}
            colWidth={33} // 25, 33, 50, 75, 100 default=25
            id='rfcChild'
            name='entityChildComponent.rfc'
            disabled={
              (isRecurrentEntityType
                ? readOnlyFields ||
                  fieldsConfiguration.rfcChild.permission !==
                    permissions.editable
                : true) ||
              entityChildComponent.entityId ||
              disabledByNotSelectedEntityChildTypeId
            }
            controlLabel={t(`${tKey}RFC`)}
            placeholder={t(`${tKey}RFC`)}
            onInputBlur={(event) => this.getEntityRfc(event)}
          />
        )}
      </>
    )
  }

  render () {
    const {
      t,
      fieldsConfiguration,
      readOnlyFields,
      dossier: {
        entityChildComponent
      }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.ENTITY.'
    return (
      <>
        <div>
          {fieldsConfiguration.dniCifValidationDisableChild && fieldsConfiguration.dniCifValidationDisableChild.permission !== permissions.hidden && entityChildComponent && entityChildComponent.entityTypeId !== entityTypesId.recurrentEntity && (
            <Field
              component={InputCheckBox}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='dniCifValidationDisableChild'
              name='entityChildComponent.dniCifValidationDisable'
              placeholder={t(`${tKey}DISABLE_DNI_CIF_VALIDATION`)}
              disabled={
                readOnlyFields ||
                    fieldsConfiguration.dniCifValidationDisableChild
                      .permission !== permissions.editable
              }
              onInputChange={(value) =>
                this.setValidationDisable(null, null, value, null)
              }
            />
          )}
          {fieldsConfiguration.representativeDniCifValidationDisableChild && fieldsConfiguration.representativeDniCifValidationDisableChild.permission !== permissions.hidden && entityChildComponent && entityChildComponent.entityTypeId === entityTypesId.businessEntity && (
            <Field
              component={InputCheckBox}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id='representativeDniCifValidationDisableChild'
              name='entityChildComponent.representativeDniCifValidationDisable'
              placeholder={t(`${tKey}DISABLE_REPR_DNI_CIF_VALIDATION`)}
              disabled={
                readOnlyFields ||
                    fieldsConfiguration
                      .representativeDniCifValidationDisableChild.permission !==
                      permissions.editable
              }
              onInputChange={(value) =>
                this.setValidationDisable(null, null, null, value)
              }
            />
          )}
          {fieldsConfiguration.freeLanceChild && fieldsConfiguration.freeLanceChild.permission !== permissions.hidden && entityChildComponent.entityTypeId === entityTypesId.privateEntity && (
            <Field
              component={InputCheckBox}
              colWidth={33} // 25, 33, 50, 75, 100 default=25
              id="freeLance"
              name="entityChildComponent.freeLance"
              placeholder={t(`${tKey}FREELANCE`)}
              disabled={readOnlyFields || fieldsConfiguration.freeLanceChild.permission !== permissions.editable}
              onInputChange={(value) => this.setFreelance(value)}
            />
          )}
        </div>
        <div>
          { this.shortSchema() }
        </div>
      </>
    )
  }
}

export default FinalClient
